import { format, parseISO } from 'date-fns';
import { useCallback } from 'react';
import { TIME_FORMAT_OUTPUT } from '../constants/time';

export type DateFormatterHook = (date: string | Date | undefined | null) => string;

export const useDateFormatter = ({
  placeholder = '',
  formatMask = TIME_FORMAT_OUTPUT,
}: { placeholder?: string | undefined; formatMask?: string | undefined } = {}) => {
  const formatDate = useCallback<DateFormatterHook>(
    (value) => {
      if (!value || !(value instanceof Date || typeof value === 'string')) {
        return placeholder;
      }
      const date = parseISO(typeof value === 'string' ? value : value.toString());
      return format(date, formatMask);
    },
    [formatMask, placeholder]
  );
  return {
    formatDate,
  };
};
